import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Authform.css'; // KEEP YOUR EXISTING CSS
import { signupUser } from '../Service/authservice';

function Signup() {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [email, setEmail] = useState('');
  const [address, setAddress] = useState(''); // ✅ NEW
  const [errors, setErrors] = useState({});

  const validatePhoneNumber = (number) => /^\d{11}$/.test(number);
  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const handleSignup = async (e) => {
    e.preventDefault();

    const newErrors = {};
    if (!username) newErrors.username = 'Username is required';
    if (!validatePhoneNumber(phoneNumber)) newErrors.phoneNumber = 'Phone number must be exactly 11 digits';
    if (!validateEmail(email)) newErrors.email = 'Please enter a valid email address';
    if (password.length < 6) newErrors.password = 'Password must be at least 6 characters long';
    if (!address) newErrors.address = 'Address is required'; // ✅ NEW

    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) return;

    try {
      const data = await signupUser({
        username,
        password,
        phoneNumber,
        email,
        address, // ✅ SENT TO BACKEND
      });

      alert(data.additionalDetail);

      if (data.code === 1) {
        navigate('/login');
      }
    } catch (error) {
      console.error('Signup Failed:', error);
      alert(error.message);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      position: 'relative',
      overflow: 'hidden',
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
      background: 'linear-gradient(135deg, #2d1b69, #5d3fd3, #9d4edd)',
    }}>

      {/* LEFT PANEL — UNCHANGED */}
      <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' }}>
        <div style={{
          textAlign: 'center',
          color: 'white',
          padding: '40px',
          backgroundColor: 'rgba(255, 255, 255, 0.1)',
          borderRadius: '20px',
          backdropFilter: 'blur(10px)',
          maxWidth: '600px',
        }}>
          <div style={{
            fontSize: '80px',
            fontWeight: '900',
            letterSpacing: '5px',
            marginBottom: '10px',
            background: 'linear-gradient(45deg, #ffffff, #e0aaff)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
          }}>
            AZ
          </div>
          <div style={{ fontSize: '28px', fontWeight: '600', marginBottom: '20px' }}>
            MANAGEMENT SYSTEM
          </div>
          <div style={{ fontSize: '18px', fontWeight: '300', marginBottom: '30px', color: '#e0aaff' }}>
            Create Your Business Account
          </div>
        </div>
      </div>

      {/* SIGNUP FORM */}
      <div style={{
        width: '400px',
        backgroundColor: 'rgba(255, 255, 255, 0.95)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '40px',
        boxShadow: '-5px 0 30px rgba(0, 0, 0, 0.2)',
      }}>
        <div style={{ width: '100%' }}>
          <form onSubmit={handleSignup}>

            {/* USERNAME */}
            <input
              type="text"
              placeholder="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              style={{ width: '100%', padding: '12px', marginBottom: '10px' }}
            />

            {/* PHONE */}
            <input
              type="text"
              placeholder="Phone Number"
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
              style={{ width: '100%', padding: '12px', marginBottom: '10px' }}
            />

            {/* EMAIL — FIXED COLOR */}
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              style={{
                width: '100%',
                padding: '12px',
                marginBottom: '10px',
                color: '#000', // ✅ FIX
              }}
            />

            {/* ADDRESS — NEW */}
            <input
              type="text"
              placeholder="Business Address"
              value={address}
              onChange={(e) => setAddress(e.target.value)}
              style={{
                width: '100%',
                padding: '12px',
                marginBottom: '10px',
              }}
            />

            {/* PASSWORD — FIXED COLOR */}
            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={{
                width: '100%',
                padding: '12px',
                marginBottom: '20px',
                color: '#000', // ✅ FIX
              }}
            />

            <button type="submit" style={{
              width: '100%',
              padding: '14px',
              background: 'linear-gradient(135deg, #7c3aed, #9d4edd)',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              fontSize: '16px',
              fontWeight: '600',
              cursor: 'pointer',
            }}>
              Create Account
            </button>
          </form>

          <p style={{ textAlign: 'center', marginTop: '20px' }}>
            Already have an account? <Link to="/login">Login</Link>
          </p>
        </div>
      </div>
    </div>
  );
}

export default Signup;
